var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-breadcrumb',{staticStyle:{"background-color":"#fff","margin-bottom":"0px","padding-top":"24px","padding-bottom":"24px","padding-inline-start":"24px"},attrs:{"items":_vm.items}})
}
var staticRenderFns = []

export { render, staticRenderFns }